module.exports = __webpack_public_path__ + "img/illustration-signin.10de4880.svg";